import { Http } from "@/plugins/http.js";

export class FeatureFlagsRepository {
  static async getFlags() {
    try {
      const { data } = await Http.get("core-feature-flags");

      return data.data;
    } catch (e) {
      console.error("FeatureFlagsRepository.getFlags", e?.response || e);
      return [];
    }
  }
}
